if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      this.loadImages();
      super.show(opener);
      this.showActiveMedia();
    }

    loadImages() {
      // Supply sources only when the customer opens the enlarged gallery.
      // Set srcset first to avoid requesting the fallback image unnecessarily.
      this.querySelectorAll('img[data-yaab-modal-src]').forEach((image) => {
        const srcset = image.getAttribute('data-yaab-modal-srcset');
        if (srcset) image.setAttribute('srcset', srcset);
        image.setAttribute('src', image.getAttribute('data-yaab-modal-src'));
        image.removeAttribute('data-yaab-modal-srcset');
        image.removeAttribute('data-yaab-modal-src');
      });
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
